/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Hero_OverlineInputs */

const en_dr_hero_overline = /** @type {(inputs: Dr_Hero_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design Room`)
};

const id_dr_hero_overline = /** @type {(inputs: Dr_Hero_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design Room`)
};

/**
* | output |
* | --- |
* | "Design Room" |
*
* @param {Dr_Hero_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_hero_overline = /** @type {((inputs?: Dr_Hero_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Hero_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_hero_overline(inputs)
	return en_dr_hero_overline(inputs)
});